import { regionRenderHash } from "./rendering";
import type { Brick, BrickRegion, MasterImage } from "./types";

const producedBricks = (masterImage: MasterImage, bricks: Brick[]) =>
  new Map(bricks.filter((b) => b.masterImage === masterImage._id).map((b) => [b.region, b]));

export const regionsToRender = (masterImage: MasterImage, bricks: Brick[]): BrickRegion[] => {
  const produced = producedBricks(masterImage, bricks);
  return masterImage.regions.filter(
    (r) => produced.get(r.id)?.renderHash !== regionRenderHash(masterImage, r)
  );
};

export const unappliedChanges = (masterImage: MasterImage, bricks: Brick[]): number => {
  const regionIds = new Set(masterImage.regions.map((r) => r.id));
  const orphans = [...producedBricks(masterImage, bricks).keys()].filter(
    (id) => id == null || !regionIds.has(id)
  ).length;
  return regionsToRender(masterImage, bricks).length + orphans;
};
